import { CssProps } from '@/utils/types';
import styled from '@emotion/styled';
import { List, ListItemButton, ListItemIcon, Typography } from '@mui/material';

interface Props {
    style?: CssProps;
    items: {
        title: string;
        icon: string;
        onClick: () => void;
        disabled?: boolean;
        selected?: boolean;
        hide?: boolean;
    }[];
}

const Divider = styled.div`
    width: 192px;
    height: 1px;
    background: #f1f2f6;
    margin-top: 10px;
    margin-bottom: 10px;
`;

const StyledListButton = styled(ListItemButton)`
    border-radius: 8px;
`;

export default function ({ style, items }: Props) {
    return (
        <List sx={style}>
            {items.map(({ title, icon, onClick, disabled, selected, hide }, i) => {
                if (hide) {
                    return null;
                }

                if (title === 'divider') {
                    return <Divider key={i} />;
                }

                return (
                    <StyledListButton
                        key={title}
                        disabled={disabled}
                        selected={selected}
                        aria-label={title}
                        onClick={e => {
                            e.stopPropagation();
                            onClick();
                        }}>
                        <ListItemIcon>
                            <img src={icon} alt="list item" width="16px" height="16px" />
                        </ListItemIcon>
                        <Typography variant="h5" fontWeight={500} lineHeight={'2.4rem'}>
                            {title}
                        </Typography>
                    </StyledListButton>
                );
            })}
        </List>
    );
}
